const accItem = document.querySelectorAll(
  ".faq-image-accordion-block .accordion-item"
);
const accImage = document.querySelectorAll(
  ".faq-image-accordion-block .img-wrap"
);
const accHD = document.querySelectorAll(
  ".faq-image-accordion-block .accordion-header"
);

for (i = 0; i < accHD.length; i++) {
  accHD[i].addEventListener("click", (e) => {
    let currentDataIndex = e.target.getAttribute("data-index");
    let currentDataIndexSplit = currentDataIndex.split("-")[0];
    let similarDataIndex = document.querySelectorAll(
      '[data-index*="' + currentDataIndexSplit + '"]'
    );
    let elements = document.querySelectorAll(
      '[data-index="' + currentDataIndex + '"]'
    );

    similarDataIndex.forEach(function (similar) {
      similar.classList.remove("active");
    });

    elements.forEach(function (element) {
      element.classList.add("active");
    });
  });
}
